import LogoExpertaSeguros from "../../assets/images/logo_experta_seguros.png";
//import LogoProvinciaSeguros from "../../assets/images/logo_provincia_seguros.png";
import LogoSancorSeguros from "../../assets/images/logo_sancor_seguros.png";
//import LogoGrupoSanCristobalSeguros from "../../assets/images/logo_grupo_san_cristobal.png";
//import LogoZurichSeguros from "../../assets/images/logo_zurich_seguros.png";
//import LogoAllianzSeguros from "../../assets/images/logo_allianz_seguros.png";
import LogoMercantilAndina from "../../assets/images/logo_mercantil_andina.png";
import LogoMeridional from "../../assets/images/logo_meridional.png";
import axiosInstance from "../axiosInstance.js";
import dayjs from "dayjs";

// Mapeo de logos por nombre de aseguradora
const INSURER_LOGOS = {
	// Experta Seguros
	"Experta": LogoExpertaSeguros,
	"Experta Seguros": LogoExpertaSeguros,
	"EXPERTA": LogoExpertaSeguros,
	
	// Provincia Seguros
	//"Provincia": LogoProvinciaSeguros,
	//"Provincia Seguros": LogoProvinciaSeguros,
	//"PROVINCIA": LogoProvinciaSeguros,
	
	// Sancor Seguros
	"Sancor": LogoSancorSeguros,
	"Sancor Seguros": LogoSancorSeguros,
	"SANCOR": LogoSancorSeguros,
	"SANCOR SEGUROS": LogoSancorSeguros,
	
	// La Mercantil Andina
	"La Mercantil Andina": LogoMercantilAndina,
	"Mercantil Andina": LogoMercantilAndina,
	"LA MERCANTIL ANDINA": LogoMercantilAndina,
	"MERCANTIL ANDINA": LogoMercantilAndina,
	"La Mercantil": LogoMercantilAndina,
	"Mercantil": LogoMercantilAndina,
	"MERCANTIL": LogoMercantilAndina,
	"la_mercantil": LogoMercantilAndina,
	
	// Grupo San Cristobal
	//"Grupo San Cristobal": LogoGrupoSanCristobalSeguros,
	//"San Cristobal": LogoGrupoSanCristobalSeguros,
	//"GRUPO SAN CRISTOBAL": LogoGrupoSanCristobalSeguros,
	//"SAN CRISTOBAL": LogoGrupoSanCristobalSeguros,
	
	// Zurich
	//"Zurich": LogoZurichSeguros,
	//"ZURICH": LogoZurichSeguros,
	//"Zurich Seguros": LogoZurichSeguros,
	
	// Allianz
	//"Allianz": LogoAllianzSeguros,
	//"ALLIANZ": LogoAllianzSeguros,
	//"Allianz Seguros": LogoAllianzSeguros,

	//Meridional
	"meridional" : LogoMeridional,
	"Meridional" : LogoMeridional
};

// Función para mapear logos de aseguradoras
const getInsurerLogo = (insurerName) => {
	//if (!insurerName) return LogoGrupoSanCristobalSeguros;
	
	// Mapeo directo
	if (INSURER_LOGOS[insurerName]) {
		return INSURER_LOGOS[insurerName];
	}
	
	// Búsqueda inteligente por palabras clave
	const normalizedName = insurerName.toLowerCase().trim();
	
	if (normalizedName.includes('mercantil')) {
		return LogoMercantilAndina;
	}
	if (normalizedName.includes('experta')) {
		return LogoExpertaSeguros;
	}
	//if (normalizedName.includes('provincia')) {
	//	return LogoProvinciaSeguros;
	//}
	if (normalizedName.includes('sancor')) {
		return LogoSancorSeguros;
	}
	//if (normalizedName.includes('cristobal') || normalizedName.includes('san cristobal')) {
	//	return LogoGrupoSanCristobalSeguros;
	//}
	//if (normalizedName.includes('zurich')) {
	//	return LogoZurichSeguros;
	//}
	//if (normalizedName.includes('allianz')) {
	//	return LogoAllianzSeguros;
	//}
	
	// Fallback por defecto
	console.warn(`Logo no encontrado para aseguradora: "${insurerName}". Usando logo por defecto.`);
	//return LogoGrupoSanCristobalSeguros;
};

// Variable global para almacenar cotizaciones
let realQuotations = null;

// Función para formatear fecha de nacimiento
const formatBirthday = (birthday) => {
	if (!birthday) return null;
	return dayjs(birthday).format("YYYY-MM-DD");
};

// Función para llamar al servicio de cotizaciones
const call_multiquote_service = async (userData) => {
	try {
		const payload = {
			datos_auto: {
				marca: userData.carData.brandName,
				modelo: userData.carData.modelName,
				anio: userData.carData.year,
				codigo_infoauto: userData.carData.codia,
				combustible: userData.carSpecialFeatures.hasGNC ? "gnc" : "nafta",
				provincia: userData.carLocation.province,
				codigo_postal: userData.carLocation.postalCode
			},
			datos_persona: {
				nombre: userData.quotationPersonalData.name,
				apellido: userData.quotationPersonalData.lastName,
				telefono: userData.quotationPersonalData.telephone,
				email: userData.quotationPersonalData.email || null,
				fecha_nacimiento: formatBirthday(userData.quotationPersonalData.birthday)
			},
			aseguradoras: ["experta", "la_mercantil","meridional","sancor"]
		};

		console.log("Enviando payload al servicio:", payload);

		const response = await axiosInstance.post('https://b2c.sysone.com/multiquote/', payload, {
			timeout: 60000,
			headers: {
				'Content-Type': 'application/json'
			}
		});

		return response.data;
	} catch (error) {
		console.error("Error al llamar al servicio de cotizaciones:", error);
		throw error;
	}
};

/**
 * Función helper para obtener información de coberturas de forma consistente
 * Prioriza el nodo config como fuente de verdad, con fallback a otras fuentes
 * 
 * @param {Object} plan - Plan de cotización del servicio
 * @returns {Object} Objeto con información de coberturas normalizada
 */
const getCoverageInfo = (plan) => {
	// Si existe config, usarlo como fuente principal
	if (plan.config) {
		return {
			// Para filtrado (boolean) - desde config
			hasHail: plan.config.hail === true,
			hasAssistance: plan.config.assistance === true,
			hasRobbery: plan.config.robbery === true,
			hasFire: plan.config.fire === true,
			hasWindows: plan.config.windows === true,
			hasDeductible: plan.config.deductible === true,
			
			// Para display (string con detalles) - desde coberturas_detalle o config
			hailDisplay: plan.coberturas_detalle?.Granizo || 
						(plan.config.hail ? "SI" : "NO"),
			crystalsDisplay: plan.coberturas_detalle?.CristalesLaterales || 
							(plan.config.windows ? "SI" : "Consultar"),
		};
	}
	
	// Fallback: calcular desde propiedades del plan (para planes sin config)
	console.warn(`Plan ${plan.codigo} no tiene config, usando fallback`);
	return {
		hasHail: !!(plan.coberturas_detalle?.Granizo?.startsWith("SI") || plan.granizo),
		hasAssistance: !!plan.auxilio_mecanico,
		hasRobbery: !!plan.robo_hurto,
		hasFire: !!plan.incendio,
		hasWindows: !!plan.cristales,
		hasDeductible: plan.franquicia > 0,
		
		hailDisplay: plan.coberturas_detalle?.Granizo || "Consultar",
		crystalsDisplay: plan.cristales || "Consultar",
	};
};

// Función para transformar la respuesta del servicio al formato del frontend
const transform_service_response = (serviceResponse) => {
	if (!serviceResponse || !serviceResponse.cotizaciones) {
		return [];
	}

	const transformedQuotations = [];
	let idCounter = 1;

	serviceResponse.cotizaciones.forEach((aseguradora) => {
		// Filtrar aseguradoras que tuvieron error
		if (aseguradora.error || !aseguradora.planes || aseguradora.planes.length === 0) {
			console.warn(`Aseguradora ${aseguradora.aseguradora} tuvo errores, se omite de los resultados`);
			return;
		}

		aseguradora.planes.forEach((plan) => {
			// Obtener información de coberturas de forma consistente desde config
			const coverageInfo = getCoverageInfo(plan);
			
			const transformedPlan = {
				id: idCounter++,
				quote_nbr: aseguradora.numero_cotizacion,
				valor_asegurado: aseguradora.vehiculo?.valor_asegurado || 0,
				companyName: aseguradora.aseguradora,
				companyLogo: getInsurerLogo(aseguradora.aseguradora),
				coverage: plan.config?.description || plan.nombre || "Cobertura",
				price: Math.round(plan.precio_efectivo || 0),
				// Precio de lista (tachado) y % de descuento "de exhibición",
				// calculados en el backend (enrichers/discount_engine.py) y
				// expuestos bajo plan.pricing. Se aísla así la política de
				// descuento del frontend, permitiendo evolucionarla desde el
				// backend (ej. motor de descuentos real) sin tocar este código.
				listPrice: plan.pricing?.precio_lista ?? null,
				discount: plan.pricing?.descuento_porcentaje ?? 0,

				
				// Propiedades para DISPLAY en UI - desde config
				crystals: coverageInfo.crystalsDisplay,
				franchise: coverageInfo.hasDeductible,
				hail: coverageInfo.hailDisplay,

				outdoorCoverage: plan.cobertura_exterior || null,
				
				// Propiedades para FILTRADO - desde config
				hasHail: coverageInfo.hasHail,
				hasLife: coverageInfo.hasAssistance,
				hasSteal: coverageInfo.hasRobbery,
				hasFire: coverageInfo.hasFire,
				hasCrystal: coverageInfo.hasWindows,
				
				// Preservar config original para referencia
				config: plan.config || null,
				
				// Datos adicionales para detalles
				coberturas_detalle: plan.coberturas_detalle,
				// HTML (<ul><li>...) con el detalle completo de coberturas provisto por
				// la aseguradora, ya generado por el backend a partir del campo "detail"
				detailHtml: plan.config?.detail || null,
				details: [
					{
						title: "Coberturas Principales",

						items: [
							coverageInfo.hasRobbery ? "Robo y Hurto Total" : null,
							coverageInfo.hasFire ? "Incendio Total y Parcial" : null,
							coverageInfo.hasHail ? "Granizo" : null,
						].filter(Boolean)
					},
					{
						title: "Servicios Adicionales",
						items: [
							coverageInfo.hasAssistance ? "Auxilio Mecánico" : null,
							coverageInfo.hasWindows ? "Cristales" : null,
							plan.cobertura_exterior ? "Cobertura en el Exterior" : null,
						].filter(Boolean)
					},
					{
						title: "Información del Plan",
						items: [
							`Código: ${plan.codigo}`,
							coverageInfo.hasDeductible && plan.franquicia ? `Franquicia: $${plan.franquicia.toLocaleString()}` : "Sin Franquicia",
							plan.suma_asegurada ? `Suma Asegurada: $${plan.suma_asegurada.toLocaleString()}` : null,
						].filter(Boolean)
					}
				],
			};

			transformedQuotations.push(transformedPlan);
		});
	});

	return transformedQuotations;
};

// Función principal para obtener cotizaciones
const get_quotations = async (userData) => {
	console.log("🔍 get_quotations llamado");
	console.log("📦 userData recibido:", userData ? "SÍ" : "NO");
	console.log("💾 Caché actual (realQuotations):", realQuotations ? `${realQuotations.length} cotizaciones` : "VACÍO");
	
	// Si ya tenemos cotizaciones en caché, las devolvemos
	if (realQuotations) {
		console.log("✅ Retornando cotizaciones desde caché:", realQuotations.length);
		return realQuotations;
	}

	// Si no se proporcionan datos de usuario y no hay caché, retornar array vacío
	if (!userData) {
		console.warn("⚠️ get_quotations llamado sin userData y sin caché - retornando array vacío");
		return [];
	}

	try {
		console.log("🌐 Llamando al servicio de cotizaciones...");
		console.log("📤 Datos enviados:", JSON.stringify(userData, null, 2));
		
		// Llamar al servicio real
		const serviceResponse = await call_multiquote_service(userData);
		
		console.log("📥 Respuesta del servicio recibida:");
		console.log("   - Número de aseguradoras:", serviceResponse?.cotizaciones?.length || 0);
		console.log("   - Respuesta completa:", JSON.stringify(serviceResponse, null, 2));
		
		// Transformar la respuesta
		const transformedQuotations = transform_service_response(serviceResponse);
		
		console.log("🔄 Cotizaciones transformadas:", transformedQuotations.length);
		console.log("   - Primeras 3 cotizaciones:", transformedQuotations.slice(0, 3));
		
		// Guardar cotizaciones para uso posterior
		realQuotations = transformedQuotations;
		console.log("💾 Cotizaciones guardadas en caché");
		
		return transformedQuotations;

	} catch (error) {
		console.error("❌ Error al obtener cotizaciones del servicio:", error);
		console.error("   - Mensaje:", error.message);
		console.error("   - Stack:", error.stack);
		throw error;
	}
};

const get_quotation_by_id = (id) => {
	if (realQuotations) {
		return realQuotations.filter((i) => i.id === id);
	}
	return [];
};

// Función para obtener lista de compañías para mostrar en Home
const get_companies = () => {
	return [
		{
			name: "Experta Seguros",
			logo: LogoExpertaSeguros
		},
		{
			name: "La Mercantil Andina",
			logo: LogoMercantilAndina
		},
		//{
		//	name: "Provincia Seguros",
		//	logo: LogoProvinciaSeguros
		//},
		{
			name: "Sancor Seguros",
			logo: LogoSancorSeguros
		},
		//{
		//	name: "Grupo San Cristobal",
		//	logo: LogoGrupoSanCristobalSeguros
		//},
		{
			name: "Meridional Seguros",
			logo: LogoMeridional
		}
	];
};

// Función para limpiar cotizaciones (útil para reset)
const clear_real_quotations = () => {
	console.log("🧹 Limpiando cache de cotizaciones");
	realQuotations = null;
};

export { 
	get_quotations, 
	get_quotation_by_id, 
	call_multiquote_service,
	clear_real_quotations,
	get_companies
};
